import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import Icon from "../../components/Icon";
import { useSelector } from "react-redux";
import { useState } from "react";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

export default () => {
  const [ isEdit, setIsEdit ] = useState({ name: "", value: ""  })
  const customer = useSelector( state => state.auth.customer )

  const handleSave = () => {

  }

  return (
    <>
      {(
        <>
          <div className="card rounded-4 p-5">
            <h4 className="custom-text-color">Profile Details</h4>
            <p className="text-secondary fs-2 m-4">
              <Icon icon={faUser} />
            </p>

            <div className="row">
              <div className="col-12">
                <div className="mb-4">
                  <label>First Name</label>
                  <div className=" d-flex ">
                    <input
                      className="input-2"
                      placeholder="Enter First Name"
                      value={isEdit.name === "firstname" ? isEdit.value : customer.firstname  }
                      readonly={isEdit.name !== "firstname"}
                      onChange={ e => setIsEdit({ ...isEdit, value: e.target.value})}
                    />
                    
                    {isEdit.name === "firstname"
                      ? <div className="d-flex" style={{ borderBottom: "2px solid #4a061b" }}>
                        <Icon icon={faXmark} className="text-danger me-2 fs-4" onClick={() => setIsEdit({ name: null, value: null })} />
                        <Icon icon={faCheck} className="text-success ms-2 fs-4" onClick={() => handleSave()} />
                      </div>
                      : <p className="text-saffron mb-0 cursor-pointer" style={{ borderBottom: "2px solid #4a061b" }} onClick={() => setIsEdit({ name: "firstname" })}>
                        Edit
                      </p>
                    }
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="mb-4">
                  <label>Last Name</label>
                  <div className=" d-flex ">
                  <input
                      className="input-2"
                      placeholder="Enter Last Name"
                      value={isEdit.name === "lastname" ? isEdit.value : customer.lastname  }
                      readonly={isEdit.name !== "lastname"}
                      onChange={ e => setIsEdit({ ...isEdit, value: e.target.value})}
                    />
                    
                    {isEdit.name === "lastname"
                      ? <div className="d-flex" style={{ borderBottom: "2px solid #4a061b" }}>
                        <Icon icon={faXmark} className="text-danger me-2 fs-4" onClick={() => setIsEdit({ name: null, value: null })} />
                        <Icon icon={faCheck} className="text-success ms-2 fs-4" onClick={() => handleSave()} />
                      </div>
                      : <p className="text-saffron mb-0 cursor-pointer" style={{ borderBottom: "2px solid #4a061b" }} onClick={() => setIsEdit({ name: "lastname" })}>
                        Edit
                      </p>
                    }
                  </div>
                </div>
              </div>


              {/* <div className="col-12">
                <div className="mb-4">
                  <label>Gender</label>
                  <div className=" d-flex ">
                    <select
                      className="input-2"
                      placeholder="Enter Display Name"
                      value={"male"}
                      readonly
                    >
                      <option className="male">Male</option>
                      <option className="female">Female</option>
                    </select>
                    <p
                      className="text-saffron mb-0 cursor-pointer ps-3"
                      style={{ borderBottom: "2px solid #4a061b" }}
                    >
                      Edit
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-12">
                <div className="mb-4">
                  <label>Phone Number</label>
                  <div className=" d-flex ">
                  <input
                      className="input-2"
                      placeholder="Enter Phone Number"
                      value={isEdit.name === "mobile" ? isEdit.value : customer.mobile  }
                      readonly={isEdit.name !== "mobile"}
                      onChange={ e => setIsEdit({ ...isEdit, value: e.target.value})}
                    />
                    
                    {isEdit.name === "mobile"
                      ? <div className="d-flex" style={{ borderBottom: "2px solid #4a061b" }}>
                        <Icon icon={faXmark} className="text-danger me-2 fs-4" onClick={() => setIsEdit({ name: null, value: null })} />
                        <Icon icon={faCheck} className="text-success ms-2 fs-4" onClick={() => handleSave()} />
                      </div>
                      : <p className="text-saffron mb-0 cursor-pointer" style={{ borderBottom: "2px solid #4a061b" }} onClick={() => setIsEdit({ name: "mobile" })}>
                        Edit
                      </p>
                    }
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="mb-4">
                  <label>Email Address</label>
                  <div className=" d-flex ">
                  <input
                      className="input-2"
                      placeholder="Enter Email Address"
                      value={isEdit.name === "email" ? isEdit.value : customer.email  }
                      readonly={isEdit.name !== "email"}
                      onChange={ e => setIsEdit({ ...isEdit, value: e.target.value})}
                    />
                    
                    {isEdit.name === "email"
                      ? <div className="d-flex" style={{ borderBottom: "2px solid #4a061b" }}>
                        <Icon icon={faXmark} className="text-danger me-2 fs-4" onClick={() => setIsEdit({ name: null, value: null })} />
                        <Icon icon={faCheck} className="text-success ms-2 fs-4" onClick={() => handleSave()} />
                      </div>
                      : <p className="text-saffron mb-0 cursor-pointer" style={{ borderBottom: "2px solid #4a061b" }} onClick={() => setIsEdit({ name: "email" })}>
                        Edit
                      </p>
                    }
                  </div>
                </div>
              </div>


              <div className="col-12">
                <div className="mb-4">
                  <label>Age</label>
                  <div className=" d-flex ">
                  <input
                      className="input-2"
                      placeholder="Enter Age"
                      value={isEdit.name === "age" ? isEdit.value : customer.age  }
                      readonly={isEdit.name !== "age"}
                      onChange={ e => setIsEdit({ ...isEdit, value: e.target.value})}
                    />
                    
                    {isEdit.name === "age"
                      ? <div className="d-flex" style={{ borderBottom: "2px solid #4a061b" }}>
                        <Icon icon={faXmark} className="text-danger me-2 fs-4" onClick={() => setIsEdit({ name: null, value: null })} />
                        <Icon icon={faCheck} className="text-success ms-2 fs-4" onClick={() => handleSave()} />
                      </div>
                      : <p className="text-saffron mb-0 cursor-pointer" style={{ borderBottom: "2px solid #4a061b" }} onClick={() => setIsEdit({ name: "age" })}>
                        Edit
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
